import ModalButtons from '@/views/components/core/ModalButtons'

export default {
  components: { ModalButtons },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:isModalActive', false)
      this.resetForm()
    },
    inputModal(value) {
      if (value === false) this.closeModal()
    },
  },
}
